/** Column keys for Auditing → Orders table (order matches default left-to-right flow). */
export const AUDIT_ORDER_COLUMN_KEYS: string[] = [
    'ro',
    'writers',
    'vin',
    'location',
    'vehicle',
    'make',
    'insurance',
    'dateStarted',
    'lastUpdated',
    'daysActive',
    'partsQuoted',
    'totalQuotes',
    'partsOrdered',
    'partsConfirmed',
    'partsExcluded',
    'partsReturnedCancelled',
    'orderValue',
    'grossProfit',
    'grossMarginPct',
    'totalMissedOpp',
    'totalVendors',
    'totalCostVariance',
    'partsInvoiced',
    'actions',
];

/** New / optional columns — hidden until the user enables them in Table settings. */
export const AUDIT_ORDER_DEFAULT_HIDDEN: string[] = [
    'writers',
    'make',
    'dateStarted',
    'partsQuoted',
    'totalQuotes',
    'partsConfirmed',
    'partsExcluded',
    'partsReturnedCancelled',
    'grossProfit',
    'totalVendors',
    'totalCostVariance',
    'partsInvoiced',
];

export const AUDIT_ORDER_PINNED_KEYS: string[] = ['ro', 'actions'];

export const AUDIT_ORDER_LABELS: Record<string, string> = {
    ro: 'RO',
    writers: 'Writers',
    vin: 'VIN',
    location: 'Location',
    vehicle: 'Vehicle (YMM)',
    make: 'Make',
    insurance: 'Insurance',
    dateStarted: 'Date Started',
    lastUpdated: 'Last Updated',
    daysActive: 'Days Active',
    partsQuoted: 'Parts Quoted',
    totalQuotes: 'Total Quotes',
    partsOrdered: 'Parts Ordered',
    partsConfirmed: 'Parts Confirmed',
    partsExcluded: 'Parts Excluded',
    partsReturnedCancelled: 'Parts Returned / Cancelled',
    orderValue: 'Order Value',
    grossProfit: 'Gross Profit',
    grossMarginPct: 'Gross Margin',
    totalMissedOpp: 'Total Missed Opportunity',
    totalVendors: 'Total Vendors',
    totalCostVariance: 'Cost Variance',
    partsInvoiced: 'Parts Invoiced',
    actions: 'Actions',
};

export const AUDIT_PART_COLUMN_KEYS: string[] = [
    'ro',
    'writers',
    'vin',
    'location',
    'vehicleYmm',
    'make',
    'insurance',
    'quoteSource',
    'partName',
    'partType',
    'quantity',
    'vendor',
    'deliveryDays',
    'dateStarted',
    'lastUpdated',
    'daysActive',
    'quotedOptionsCount',
    'originalListPrice',
    'buyPrice',
    'listPrice',
    'partListPricePctOfOE',
    'grossMarginPct',
    'missedOpportunity',
    'isInvoiced',
    'costVariance',
    'invoicedCost',
    'invoiceDate',
    'finalEta',
    'actions',
];

export const AUDIT_PART_DEFAULT_HIDDEN: string[] = [
    'writers',
    'vehicleYmm',
    'quoteSource',
    'dateStarted',
    'lastUpdated',
    'daysActive',
    'quotedOptionsCount',
    'isInvoiced',
    'costVariance',
    'invoicedCost',
    'invoiceDate',
    'finalEta',
];

export const AUDIT_PART_PINNED_KEYS: string[] = ['ro', 'actions'];

export const AUDIT_PART_LABELS: Record<string, string> = {
    ro: 'RO',
    writers: 'Writers',
    vin: 'VIN',
    location: 'Location',
    vehicleYmm: 'Vehicle (YMM)',
    make: 'Make',
    insurance: 'Insurance',
    quoteSource: 'Source',
    partName: 'Part Name',
    partType: 'Part Type',
    quantity: 'Qty',
    vendor: 'Vendor',
    deliveryDays: 'Delivery',
    dateStarted: 'Date Started',
    lastUpdated: 'Last Updated',
    daysActive: 'Days Active',
    quotedOptionsCount: 'Options Quoted',
    originalListPrice: 'Orig. List $',
    buyPrice: 'Buy $',
    listPrice: 'Adj. List $',
    partListPricePctOfOE: '% of OEM List',
    grossMarginPct: 'Gross Margin',
    missedOpportunity: 'Missed Opportunity',
    isInvoiced: 'Invoiced',
    costVariance: 'Cost Variance',
    invoicedCost: 'Invoiced Cost',
    invoiceDate: 'Invoice Date',
    finalEta: 'Final ETA',
    actions: 'Actions',
};
